import getVersionControl from "pxc-editor-web/environment_modules/common/helpers/getVersionControl";
export default (function (project) {
    return getVersionControl({
        creator_app_id: 'CMME',
        creator_app_name: 'Marking Configurator Web app',
    }, project);
});
